import { render, staticRenderFns } from "./SmsOptIn.vue?vue&type=template&id=54d90294"
import script from "./SmsOptIn.vue?vue&type=script&lang=ts"
export * from "./SmsOptIn.vue?vue&type=script&lang=ts"
import style0 from "./SmsOptIn.vue?vue&type=style&index=0&id=54d90294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports